import { fromJS, List } from 'immutable';
import * as reduxHelper from 'store/utils/reduxHelper';
import Result from 'models/ImpactPlan/Result';
import { byId } from 'store/utils/sortFunctions';

import types from './types';

export const initialState = fromJS({
  ...reduxHelper.applyReceiveInfo({
    data: { byId: {}, bySystem: {} },
    errorMessage: '',
    updatePending: false,
  }),
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case types.RESULTS_LIST_SUCCEEDED:
      return state.merge(
        reduxHelper.applyReceiveInfo({
          data: {
            byId: action.payload.results.reduce(
              (obj, result) => ({ ...obj, [result.id]: new Result(result) }),
              state.get('data').get('byId')
            ),
            bySystem: state
              .get('data')
              .get('bySystem')
              .set(
                String(action.payload.system),
                fromJS(action.payload.results.map(result => new Result(result)).sort(byId))
              ),
          },
        })
      );
    case types.RESULT_FETCH_SUCCEEDED:
    case types.RESULT_CREATE_SUCCEEDED:
    case types.RESULT_UPDATE_SUCCEEDED:
      return (() => {
        const systemId = String(action.payload.system);
        const systemResults = state
          .get('data')
          .get('bySystem')
          .get(systemId, new List())
          .filter(result => result.id !== action.payload.id)
          .push(new Result(action.payload))
          .sort(byId);
        return state.merge(
          reduxHelper.applyReceiveInfo({
            updatePending: false,
            data: {
              byId: state
                .get('data')
                .get('byId')
                .set(String(action.payload.id), new Result(action.payload)),
              bySystem: state.get('data').get('bySystem').set(systemId, systemResults),
            },
          })
        );
      })();
    case types.RESULT_FETCH:
    case types.RESULT_CREATE:
    case types.RESULT_UPDATE:
      return state.merge(
        reduxHelper.applyRequestInfo({
          updatePending: true,
        })
      );
    case types.RESULT_DELETE_SUCCEEDED:
      return state.merge(
        reduxHelper.applyReceiveInfo({
          updatePending: false,
          data: {
            byId: state.get('data').get('byId').delete(String(action.payload.id)),
            bySystem: state
              .get('data')
              .get('bySystem')
              .set(
                String(action.payload.system),
                state
                  .get('data')
                  .get('bySystem')
                  .get(String(action.payload.system), new List())
                  .filter(result => result.id !== action.payload.id)
              ),
          },
        })
      );
    case types.RESULT_UPDATE_FAILED:
      return state.merge(
        reduxHelper.applyErrorInfo({
          updatePending: false,
          errorMessage: action.payload,
        })
      );
    case types.RESULT_CLEAR_ERROR:
      return state.merge(reduxHelper.applyReceiveInfo());
    case types.RESULT_FETCH_FAILED:
    case types.RESULTS_LIST_FAILED:
      return state.merge(
        reduxHelper.applyErrorInfo({
          errorMessage: action.payload,
        })
      );
    default:
      return state;
  }
}
